import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";
import { FichaHorario, HorariosLista, OcupacionAulas, OpcionesHorarios, PlanCambioHora, SesionHorario } from "../../navigation/v2/managment/horarios/interfaces";

const base = (campusId: number) => `/admin/campus/${campusId}/schedules`;

export interface FiltrosLista {
	tab: string;
	q?: string;
	courseIds?: number[];
	levelIds?: number[];
	mentorIds?: number[];
	classroomIds?: number[];
	weekDays?: number[];
	periodIds?: number[];
	kitPendiente?: boolean;
	page?: number;
	perPage?: number;
}

/*
	Horarios Claros (2026-11-01): lista, opciones de las pastillas, ocupación de aulas y ficha del horario. El contrato está en
	docs/HORARIOS_CLAROS_BRIEF.md. Alumnas, sesiones, notas e historial siguen en sus endpoints de siempre.
*/
export class HorariosService {
	lista = async (campusId: number, f: FiltrosLista): Promise<AxiosResponse<HorariosLista>> => {
		const params: any = { tab: f.tab, page: f.page || 1, perPage: f.perPage || 50 };
		if (f.q) { params.q = f.q; }
		if (f.courseIds?.length) { params.courseIds = f.courseIds; }
		if (f.levelIds?.length) { params.levelIds = f.levelIds; }
		if (f.mentorIds?.length) { params.mentorIds = f.mentorIds; }
		if (f.classroomIds?.length) { params.classroomIds = f.classroomIds; }
		if (f.weekDays?.length) { params.weekDays = f.weekDays; }
		if (f.periodIds?.length) { params.periodIds = f.periodIds; }
		if (f.kitPendiente) { params.kitPendiente = 1; }
		return axiosInstance.get<HorariosLista>(`${base(campusId)}/_lista`, { params });
	};

	opciones = async (campusId: number): Promise<AxiosResponse<OpcionesHorarios>> =>
		axiosInstance.get<OpcionesHorarios>(`${base(campusId)}/_opciones`);

	ocupacion = async (campusId: number, weekDay: number, buildingId?: number | null): Promise<AxiosResponse<OcupacionAulas>> =>
		axiosInstance.get<OcupacionAulas>(`${base(campusId)}/_ocupacion`, { params: { weekDay, ...(buildingId ? { buildingId } : {}) } });

	ficha = async (campusId: number, id: number): Promise<AxiosResponse<FichaHorario>> =>
		axiosInstance.get<FichaHorario>(`${base(campusId)}/${id}/_ficha`);

	/** Horarios Claros fase 2: Qué Va a Pasar si el horario pasa a esas sesiones (no escribe). */
	vistaPreviaCambioHora = async (campusId: number, id: number, sesiones: SesionHorario[]): Promise<AxiosResponse<PlanCambioHora>> =>
		axiosInstance.get<PlanCambioHora>(`${base(campusId)}/${id}/_cambiarHora`, { params: { sesiones: JSON.stringify(sesiones) } });

	cambiarHora = async (campusId: number, id: number, body: { sesiones: SesionHorario[]; motivo: string; forzarChoque?: { motivo: string } }): Promise<AxiosResponse<PlanCambioHora>> =>
		axiosInstance.put<PlanCambioHora>(`${base(campusId)}/${id}/_cambiarHora`, body);

	/** «Usar Hora de las Clases»: rehace el nombre desde las sesiones. */
	nombreDesdeSesiones = async (campusId: number, id: number, motivo?: string): Promise<AxiosResponse<{ nombreAntes: string; nombreDespues: string; cambio: boolean }>> =>
		axiosInstance.put(`${base(campusId)}/${id}/_nombreDesdeSesiones`, { motivo: motivo || null });

	alumnas = async (campusId: number, id: number): Promise<AxiosResponse<any[]>> =>
		axiosInstance.get<any[]>(`${base(campusId)}/${id}/_students`);
}
